// src/components/intake/bodies/MultiBody.jsx
import React from "react";
import {
  OTHER_MAX,
  OptionCard,
  OptionGrid,
  SetLabel,
  TextAnswer,
} from "../IntakeParts";
import { toggled } from "../intakeRules";
import { CLICK_ALL, SOMETHING_ELSE } from "../intakeCopy";

// Q2 (kind `multi`): tick any + "Something else".
export default function MultiBody({ page, draft, onChange, idPrefix }) {
  const options = page.questions[0].options;
  const labelId = `${idPrefix}-set-label`;
  return (
    <>
      <SetLabel id={labelId}>{CLICK_ALL}</SetLabel>
      <OptionGrid labelledBy={`${idPrefix}-h1 ${labelId}`}>
        {options.map((option) => (
          <OptionCard
            key={option}
            label={option}
            checked={draft.selected.includes(option)}
            mark={draft.selected.includes(option) ? "✓" : null}
            onChange={() =>
              onChange({
                ...draft,
                selected: toggled(options, draft.selected, option),
              })
            }
          />
        ))}
      </OptionGrid>
      <TextAnswer
        id={`${idPrefix}-other`}
        label={SOMETHING_ELSE}
        value={draft.other}
        max={OTHER_MAX}
        onChange={(other) => onChange({ ...draft, other })}
      />
    </>
  );
}
